/* ============================================================
   Coat & Clover Cart Drawer — UpCart-style behaviour
   Slide-out · inline AJAX · upsell carousel · straight to checkout.
   Intercepts Dawn's add-to-cart forms + the header cart icon, and
   defensively neutralises the live UpCart app so there is never a
   double drawer while the app embed is still enabled.
   ============================================================ */
/* ---------- DEAD-END SENTINEL (standalone — must survive anything) ----------
   Ported from kh 2026-08-04 after a Kaching Bundles app update silently killed
   Konah Home's add-to-cart -> drawer -> checkout path for ~15h (app JS changes
   with no theme push and can swallow click/submit events before the drawer
   sees them). Guarantee: after any tap on something clickable, if the cart
   count GREW but no drawer is visible ~1.5-4s later, send the buyer to /cart.
   Standalone IIFE, window-capture pointerdown, once per pageview, never on
   /cart or /checkout pages. See konah-home/kh-cart-drawer.js for full spec. */
(function () {
  'use strict';
  var busy = false, done = false;
  function count(cb) {
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cb(c && typeof c.item_count === 'number' ? c.item_count : null); })
        .catch(function () { cb(null); });
    } catch (e) { cb(null); }
  }
  function drawerVisible() {
    var d = document.getElementById('cccdDrawer');
    return !!(d && !d.hidden && d.classList.contains('is-open'));
  }
  function onCartOrCheckout() {
    var p = location.pathname;
    return p.indexOf('/cart') === 0 || p.indexOf('checkout') !== -1;
  }
  window.addEventListener('pointerdown', function (e) {
    try {
      if (busy || done || onCartOrCheckout()) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('button, [role="button"], [type="submit"], [name="add"], input, a, form, [class*="kaching"], [class*="bundle"], [class*="atc"], [class*="add-to-cart"]')) return;
      busy = true;
      var baseline = null;
      count(function (n) { baseline = n; });
      [1500, 2600, 3900].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (done || drawerVisible() || onCartOrCheckout()) return;
            count(function (n) {
              if (done || drawerVisible() || onCartOrCheckout()) return;
              if (baseline !== null && n !== null && n > baseline) {
                done = true;
                window.location.href = '/cart';
              }
            });
          } catch (err) {}
        }, ms);
      });
      setTimeout(function () { busy = false; }, 4600);
    } catch (err) {}
  }, true);
})();

(function () {
  'use strict';

  /* ---------- neutralise UpCart (runs even before drawer nodes exist) ----------
     Visual hiding of UpCart's nodes is done by CSS (#upCart etc. → display:none
     !important), which cannot loop. Here we only clear UpCart's body scroll-lock
     class, and ONLY when it is actually present, so we never self-trigger. The
     observer is childList-only and self-disconnects while it runs, so writing to
     the DOM inside it can never feed back into another mutation record. */
  var kcObs;
  function killUpCart() {
    if (kcObs) kcObs.disconnect();
    if (document.body.classList.contains('upcartPopupShow')) {
      document.body.classList.remove('upcartPopupShow');
    }
    if (kcObs) { try { kcObs.observe(document.body, { childList: true }); } catch (e) {} }
  }
  try {
    kcObs = new MutationObserver(killUpCart);
    kcObs.observe(document.body, { childList: true });
  } catch (e) {}
  killUpCart();

  var overlay = document.getElementById('cccdOverlay');
  var drawer  = document.getElementById('cccdDrawer');
  if (!drawer || !overlay) return;

  var closeBtn    = document.getElementById('cccdClose');
  var itemsEl     = document.getElementById('cccdItems');
  var countEl     = document.getElementById('cccdCount');
  var footerEl    = document.getElementById('cccdFooter');
  var lowStockEl  = document.getElementById('cccdLowStock');
  var lowTextEl   = document.getElementById('cccdLowStockText');
  var upsellEl    = document.getElementById('cccdUpsell');
  var upsellTrack = document.getElementById('cccdUpsellTrack');
  var checkoutTotalEl = document.getElementById('cccdCheckoutTotal');
  var rewardMsgEl = document.getElementById('cccdRewardMsg');
  var barFillEl   = document.getElementById('cccdBarFill');

  var CFG    = window.cccdConfig || {};
  var THRESH = CFG.threshold || 4000;

  /* ---------- speed state (optimistic UI) ----------
     pendingQty holds quantities the user has tapped to but the server hasn't
     confirmed yet; render() must never clobber those rows. lastKeysSig lets
     render() skip full innerHTML rebuilds (and image reloads) when the set of
     cart lines is unchanged. lastUpsellSig caches the upsell fetch. */
  var pendingQty = {}, qtyTimers = {};
  var lastKeysSig = null, lastUpsellSig = null;
  var lastCount = 0;   /* last item_count the drawer has rendered — pre-add baseline for the Kaching watcher */

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var amt = (cents || 0) / 100.0;
    function commas(s) { return s.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key === 'amount_no_decimals') return commas(Math.round(amt).toFixed(0) + '.').slice(0, -1);
      if (key === 'amount_with_comma_separator') return commas(amt.toFixed(2)).replace('.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return commas(Math.round(amt).toFixed(0));
      return commas(amt.toFixed(2));
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    overlay.hidden = false; drawer.hidden = false;
    void drawer.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function thumb(url, px) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + px + 'x' + px + '$1$2');
  }

  var TRASH = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';

  function itemHTML(it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    if (img) img = thumb(img, 200);
    var variant = (it.variant_title && it.variant_title !== 'Default Title')
      ? '<div class="cccd-item-variant">' + esc(it.variant_title) + '</div>' : '';
    var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
    var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
    var compare = (cmpLine > it.final_line_price)
      ? '<span class="cccd-price-compare">' + formatMoney(cmpLine) + '</span>' : '';
    return '' +
      '<div class="cccd-item" data-key="' + esc(it.key) + '">' +
        '<a class="cccd-item-img" href="' + esc(it.url) + '">' +
          (img ? '<img src="' + esc(img) + '" width="88" height="88" loading="lazy" alt="' + esc(it.product_title) + '">' : '') +
        '</a>' +
        '<div class="cccd-item-main">' +
          '<div class="cccd-item-titlerow">' +
            '<span class="cccd-item-title">' + esc(it.product_title) + '</span>' +
            '<button class="cccd-remove" data-key="' + esc(it.key) + '" type="button" aria-label="Remove">' + TRASH + '</button>' +
          '</div>' +
          variant +
          '<div class="cccd-item-bottom">' +
            '<div class="cccd-qty">' +
              '<button type="button" data-action="decrease" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">−</button>' +
              '<span class="cccd-qty-val">' + it.quantity + '</span>' +
              '<button type="button" data-action="increase" data-key="' + esc(it.key) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="cccd-item-price">' + compare +
              '<span class="cccd-price-final">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function syncHeaderBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        icon.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count < 100 ? count : '';
    } else if (bubble) {
      bubble.remove();
    }
  }

  /* Fast path: update qty/prices on existing rows without rebuilding the DOM
     (keeps <img> nodes alive — no reload/flicker). Skips rows with unconfirmed
     optimistic quantities so the user's taps are never visually reverted. */
  function renderInPlace(cart) {
    cart.items.forEach(function (it) {
      var row = itemsEl.querySelector('.cccd-item[data-key="' + it.key + '"]');
      if (!row) return;
      if (!pendingQty.hasOwnProperty(it.key)) {
        var v = row.querySelector('.cccd-qty-val');
        if (v) v.textContent = it.quantity;
        row.classList.remove('cccd-item--removing');
      }
      var pf = row.querySelector('.cccd-price-final');
      if (pf) pf.textContent = formatMoney(it.final_line_price);
      var cmpUnit = it.original_price && it.original_price > it.final_price ? it.original_price : 0;
      var cmpLine = cmpUnit ? cmpUnit * it.quantity : 0;
      var pc = row.querySelector('.cccd-price-compare');
      if (cmpLine > it.final_line_price) {
        if (pc) { pc.textContent = formatMoney(cmpLine); }
        else {
          var pr = row.querySelector('.cccd-item-price');
          if (pr) pr.insertAdjacentHTML('afterbegin', '<span class="cccd-price-compare">' + formatMoney(cmpLine) + '</span>');
        }
      } else if (pc) { pc.remove(); }
    });
  }

  function render(cart) {
    lastCount = cart.item_count;
    if (countEl) countEl.textContent = cart.item_count;
    syncHeaderBubble(cart.item_count);

    if (cart.total_price >= THRESH) {
      rewardMsgEl.innerHTML = 'Free shipping unlocked!';
    } else {
      rewardMsgEl.innerHTML = 'You’re <b>' + formatMoney(THRESH - cart.total_price) + '</b> away from free shipping!';
    }
    if (barFillEl) barFillEl.style.width = Math.min(100, Math.round((cart.total_price * 100) / THRESH)) + '%';

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="cccd-empty">' +
          '<svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/products/detangling-comb">Shop the comb</a>' +
        '</div>';
      footerEl && footerEl.classList.add('is-hidden');
      lowStockEl && lowStockEl.classList.add('is-hidden');
      upsellEl && upsellEl.classList.add('is-hidden');
      lastKeysSig = null; lastUpsellSig = null;
    } else {
      var keysSig = cart.items.map(function (i) { return i.key; }).join('|');
      if (keysSig === lastKeysSig && itemsEl.querySelector('.cccd-item')) {
        renderInPlace(cart);
      } else {
        itemsEl.innerHTML = cart.items.map(itemHTML).join('');
        lastKeysSig = keysSig;
      }
      footerEl && footerEl.classList.remove('is-hidden');
      lowStockEl && lowStockEl.classList.remove('is-hidden');
      if (lowTextEl) {
        lowTextEl.textContent = cart.item_count === 1
          ? 'One item in your cart is low in stock.'
          : 'Some items in your cart are low in stock.';
      }
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price);
      loadUpsells(cart);
    }
  }

  /* ---------- upsell carousel ("You'll love these") ---------- */
  function loadUpsells(cart) {
    if (!upsellEl || !upsellTrack || !cart.items.length) { upsellEl && upsellEl.classList.add('is-hidden'); return; }
    var seedId = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    /* cache: same seed + same in-cart set already rendered → no refetch */
    var sig = seedId + '|' + Object.keys(inCart).sort().join(',');
    if (sig === lastUpsellSig && upsellTrack.children.length) {
      upsellEl.classList.remove('is-hidden');
      return;
    }
    fetch('/recommendations/products.json?product_id=' + seedId + '&limit=8&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) { return !inCart[p.id] && p.available !== false; });
        if (!products.length) { upsellEl.classList.add('is-hidden'); lastUpsellSig = null; return; }
        upsellTrack.innerHTML = products.map(upsellCardHTML).join('');
        upsellEl.classList.remove('is-hidden');
        lastUpsellSig = sig;
        updateArrows();
      })
      .catch(function () { upsellEl.classList.add('is-hidden'); lastUpsellSig = null; });
  }

  function upsellCardHTML(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available !== false; });
    if (!variants.length) variants = p.variants || [];
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && typeof img === 'object') img = img.src || '';
    img = thumb(img, 180);
    var price = variants[0] ? variants[0].price : p.price;
    var select = '';
    if (variants.length > 1) {
      select = '<select class="cccd-upsell-select" aria-label="Choose option">' +
        variants.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') +
      '</select>';
    }
    var firstVid = variants[0] ? variants[0].id : '';
    return '' +
      '<div class="cccd-upsell-card">' +
        '<div class="cccd-upsell-img">' + (img ? '<img src="' + esc(img) + '" loading="lazy" alt="' + esc(p.title) + '">' : '') + '</div>' +
        '<div class="cccd-upsell-info">' +
          '<span class="cccd-upsell-name">' + esc(p.title) + '</span>' +
          '<span class="cccd-upsell-price">' + formatMoney(price) + '</span>' +
          '<div class="cccd-upsell-row">' + select +
            '<button class="cccd-upsell-add" type="button" data-vid="' + firstVid + '">Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function updateArrows() {
    var prev = document.getElementById('cccdUpsellPrev');
    var next = document.getElementById('cccdUpsellNext');
    if (!prev || !next) return;
    var max = upsellTrack.scrollWidth - upsellTrack.clientWidth - 2;
    prev.disabled = upsellTrack.scrollLeft <= 2;
    next.disabled = upsellTrack.scrollLeft >= max;
  }

  /* ---------- cart API ---------- */
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(render); }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }
  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function () { return refresh(); }).then(open);
  }
  function addFormData(fd) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); }).then(function () { return refresh(); }).then(open);
  }

  window.mpCartDrawer = { open: open, close: close, addItem: addItem, refresh: refresh };

  /* ---------- Kaching Bundles add-watcher ----------
     The Duo/Trio bundle bars hijack the ATC click and POST /cart/add themselves,
     so no form-submit fires and the capture-phase interceptor never opens the
     drawer on bundle adds. A fetch-net (like tsv's) does NOT work here: Kaching
     loads in <head> and holds an early fetch reference, so it bypasses any later
     window.fetch wrapper. Instead: after any add-to-cart click, run a few bounded
     cart-count checks and open the drawer if the count grew past the last count
     the drawer rendered. Transport- and load-order-agnostic. NOT a continuous
     poll (a handful of checks per click, stops on first detection) — so it does
     not trip Shopify's bot-signal checkout captcha the way the old Omega 1s
     /cart.json poll did. Added 2026-07-21. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[name="add"], form[action*="/cart/add"] [type="submit"], .kaching-bundles, [class*="kaching-bundles"]')) return;
    var baseline = lastCount;   /* synchronous, pre-add — no fetch race */
    [500, 1100, 1800, 2600].forEach(function (ms) {
      setTimeout(function () {
        if (drawer.classList.contains('is-open')) return;
        fetchCart().then(function (c) {
          if (c.item_count > baseline && !drawer.classList.contains('is-open')) { render(c); open(); }
        }).catch(function () {});
      }, ms);
    });
  }, true);

  /* ---------- delegated: qty / remove (OPTIMISTIC — instant UI, debounced sync) ----------
     The number bumps at tap time (0ms feedback); one /cart/change.js call with
     the final quantity fires 300ms after the last tap. Rapid taps = one request. */
  function queueQty(key, qty) {
    pendingQty[key] = qty;
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var q = pendingQty[key];
      delete pendingQty[key]; delete qtyTimers[key];
      changeQty(key, q);
    }, 300);
  }
  itemsEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cccd-qty button');
    if (qtyBtn) {
      var row = qtyBtn.closest('.cccd-item');
      var key = qtyBtn.getAttribute('data-key');
      var valEl = row.querySelector('.cccd-qty-val');
      var cur = pendingQty.hasOwnProperty(key) ? pendingQty[key] : (parseInt(valEl.textContent, 10) || 0);
      var next = qtyBtn.getAttribute('data-action') === 'increase' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      valEl.textContent = next;
      row.classList.toggle('cccd-item--removing', next === 0);
      queueQty(key, next);
      return;
    }
    var rm = e.target.closest('.cccd-remove');
    if (rm) {
      var k = rm.getAttribute('data-key');
      var r2 = rm.closest('.cccd-item');
      if (r2) r2.classList.add('cccd-item--removing');
      queueQty(k, 0);
    }
  });

  /* ---------- delegated: upsell add + variant select + arrows ---------- */
  if (upsellEl) {
    upsellEl.addEventListener('change', function (e) {
      var sel = e.target.closest('.cccd-upsell-select');
      if (!sel) return;
      var btn = sel.parentElement.querySelector('.cccd-upsell-add');
      var opt = sel.options[sel.selectedIndex];
      if (btn) btn.setAttribute('data-vid', sel.value);
      var priceEl = sel.closest('.cccd-upsell-info').querySelector('.cccd-upsell-price');
      if (priceEl && opt && opt.getAttribute('data-price')) priceEl.textContent = formatMoney(parseInt(opt.getAttribute('data-price'), 10));
    });
    upsellEl.addEventListener('click', function (e) {
      var add = e.target.closest('.cccd-upsell-add');
      if (add) {
        var vid = add.getAttribute('data-vid');
        if (vid) { add.textContent = 'Adding…'; add.disabled = true; addItem(vid, 1); }
        return;
      }
      var prev = e.target.closest('#cccdUpsellPrev');
      var next = e.target.closest('#cccdUpsellNext');
      if (prev || next) {
        upsellTrack.scrollBy({ left: (prev ? -1 : 1) * upsellTrack.clientWidth, behavior: 'auto' });
        /* programmatic scrollBy does not reliably fire a 'scroll' event, so refresh arrow state directly */
        updateArrows();
      }
    });
    upsellTrack && upsellTrack.addEventListener('scroll', updateArrows, { passive: true });
  }

  /* ---------- checkout: straight to checkout, skip cart page ---------- */
  var checkoutBtn = document.getElementById('cccdCheckout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      checkoutBtn.style.opacity = '.7';
      /* Publish a storefront event the Customer-Events pixel can subscribe to.
         Shopify's own `checkout_started` has never reached the Meta pixel on this
         store (0 InitiateCheckout against 2 completed orders, 09-14 Aug), while
         Purchase fires fine from the order-status page. Rather than depend on an
         event that demonstrably does not arrive, fire our own at the moment the
         buyer commits. The pixel dedupes the two by event_id. */
      try {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
              Shopify.analytics.publish('cc_checkout_click', {
                value: (c.total_price || 0) / 100,
                currency: c.currency,
                num_items: c.item_count,
                content_ids: (c.items || []).map(function (i) { return String(i.variant_id); }),
                event_id: 'cc_ic_' + (c.token || '') + '_' + Math.floor(Date.now() / 60000)
              });
            }
          }).catch(function () {});
      } catch (err) {}
      window.location.href = '/checkout';
    });
  }

  /* ---------- intercept ADD-TO-CART forms (capture phase → beats Dawn + UpCart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation();
    var submitBtn = form.querySelector('[type="submit"], [name="add"]');
    if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
    /* perceived speed: open the drawer immediately with a subtle loading state;
       the new item pops in when the add completes */
    open();
    drawer.classList.add('is-adding');
    addFormData(new FormData(form)).catch(function () {}).then(function () {
      drawer.classList.remove('is-adding');
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
    });
  }, true);

  /* ---------- intercept cart triggers → open drawer (never /cart) ---------- */
  function bindCartTriggers() {
    var sels = '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], [data-mp-cart-open]';
    document.querySelectorAll(sels).forEach(function (el) {
      if (el.__mpBound) return; el.__mpBound = true;
      el.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); refresh(); open(); });
    });
  }
  bindCartTriggers();
  document.addEventListener('DOMContentLoaded', bindCartTriggers);
})();

